import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=0d8a6016&scoped=true"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=0d8a6016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a6016",
  null
  
)

export default component.exports